import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import HRule from '../../atoms/HRule'
import TextCallout from '../../molecules/TextCallout'
import Paper from '../../atoms/Paper'
import LogoTitle from '../../molecules/LogoTitle'
import PasswordRecoveryRequested from '../../organisms/PasswordRecoveryRequested'

import medias from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

const HRuleWrapper = styled(View)`
  margin-top: 34px;
  margin-right: 0;
  margin-bottom: 28px;
  margin-left: 0;
`

const TemplateWrapper = styled(View)`
  margin: 16px 0;
`

const Title = styled.span.attrs({ className: 'typo-body-large' })`
  text-align: center;
  font-size: 20px;
  margin-top: var(--spacing-3);
  margin-bottom: var(--spacing-3);
  font-weight: var(--font-weight-semibold);
`

const PaperWrapper = styled(Paper)`
  border: 1px solid var(--color-neutral-90);
`

export const PasswordResetEmailSentPage = props => {
  const { email, onSuccess, onSubmit, onError, abTests } = props
  return (
    <Content>
      <PaperWrapper>
        <LogoTitle>
          <Title>Confira seu e-mail, e siga as instruções de segurança</Title>
        </LogoTitle>
        <TemplateWrapper>
          <PasswordRecoveryRequested
            email={email}
            onSuccess={onSuccess}
            onSubmit={onSubmit}
            onError={onError}
            abTests={abTests}
          />
        </TemplateWrapper>
        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>
        <TextCallout text="Voltar para" linkText="Entrar" href="/acesso" />
      </PaperWrapper>
    </Content>
  )
}

PasswordResetEmailSentPage.propTypes = {
  email: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  abTests: PropTypes.string,
}
